export const buildAbsoluteUrl = (url) => {
  if (!url) return window.location.href;
  if (/^https?:\/\//i.test(url)) return url;
  return `${window.location.origin}${url}`;
};

export const shareOrCopyUrl = async ({ url, title, text, usePageMetadata = false } = {}) => {
  const shareUrl = buildAbsoluteUrl(url);
  const shareData = usePageMetadata
    ? { url: shareUrl }
    : {
        title: title || document.title,
        text: text || undefined,
        url: shareUrl,
      };

  if (navigator.share) {
    try {
      await navigator.share(shareData);
      return 'shared';
    } catch (err) {
      if (err?.name === 'AbortError') {
        return 'cancelled';
      }
    }
  }

  // Preserve escaped spaces/delimiters: decoding can turn one URL into several
  // words when pasted into a messenger, or throw for a literal percent sign.
  const copy = usePageMetadata ? '' : text?.trim().replace(/\s+/g, ' ');
  await navigator.clipboard.writeText([copy, shareUrl].filter(Boolean).join('\n'));
  return 'copied';
};
